<p-pickList [disabled]="editMode" [source]="userList" [target]="destList" sourceHeader="{{'Users' | translate}}" targetHeader="{{'UsersD' | translate}}" [responsive]="true" filterBy="displayValue" 
    [showSourceControls]="false" [showTargetControls]="false" (onMoveToTarget)="moveToTarget($event)" (onMoveToSource)="moveToSource($event)"
    dragdrop="true" sourceFilterPlaceholder="{{'Filter_A' | translate}}" targetFilterPlaceholder="{{'Filter_A' | translate}}" [sourceStyle]="{'height':'300px'}" [targetStyle]="{'height':'300px'}">
    <ng-template let-user pTemplate="item">
        <div>
            <div style="font-size:14px;float:left">{{user.displayValue}}</div>
        </div>
    </ng-template>
</p-pickList>
